import { render, staticRenderFns } from "./DetailInsentifHelpdesk.vue?vue&type=template&id=45f10e50"
import script from "./DetailInsentifHelpdesk.vue?vue&type=script&lang=js"
export * from "./DetailInsentifHelpdesk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports